import React, { Component } from 'react';
import {  Button , Container , Dimmer, Form , Header , Icon , Label , Loader , Modal , Progress , Table } from 'semantic-ui-react'; 
import * as constantes from '../../constantes';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;
const serverPu = constantes.REST_API_PUBLIC;

const style = {
  h1: {
    marginTop: '1em',
  },
  h2: {
    margin: '1em 0em 1em',
  },
  h3: {
    marginTop: '2em',
    padding: '2em 0em',
  },
  last: {
    marginBottom: '300px',
  },
}

export default class Plantillas extends Component{

  constructor(props) {
      super(props);
      this.state = {
          isLoaded: false,
          error: null,
          errors: [],

          listaPlantillas: [],

          showDimmerModalWord:false,
          showModalWord:false,
          modalWordErrorLabel:'',
          resolucionRacPlantillaId_word : null ,
          up_file: null,
          up_fileName: "",
          up_isUploading: false,
          up_statusCode: ""

      };
  
    }

    setShowModalWord( mostrar ){
        this.setState({
        showModalWord: mostrar
        });
    }

    componentDidMount(){
        auth0Client.isExpired();
        this.cargarLista();
    }

  async cargarLista( ){
    let METHODNAME = 'cargarLista - ';
    console.log(METHODNAME + 'INI');

    let url = server+`/resolucionRacPlantilla`;
   
    fetch( 
        url , {
        method: 'GET',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
        }
    })
    .then(res => res.json())
    .then(
        
        (result) => {
            console.log(METHODNAME + 'RESULTADO DE LISTA DE FERIADOS');
            
            this.setState({
                isLoaded: true,
                listaPlantillas: result.listaResolucionRacPlantillas
            }); 

        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            console.log(METHODNAME + 'error = ' + error );
            this.setState({
                isLoaded: true,
                error
            });
        }
    )
    console.log(METHODNAME + 'FIN');
    }

    cargarWord( resolucionRacPlantillaId ){
        let METHODNAME = 'cargarWord - ';
        console.log( METHODNAME + 'INI ');

        console.log( METHODNAME + 'resolucionRacPlantillaId =  ' + resolucionRacPlantillaId );
       
        this.setState({
            modalWordErrorLabel : '',

            up_file: null,
            up_fileName: "",
            up_isUploading: false,
            up_statusCode: "" ,

            resolucionRacPlantillaId_word : resolucionRacPlantillaId , 
            showModalWord : true ,
            showDimmerModalWord : false
             
        }); 
 
    }

    onFormSubmit = e => {
        e.preventDefault(); // Stop form submit
        console.log("form submit");
        if( this.state.up_file ){
            this.setState({
                modalWordErrorLabel : '',
                showDimmerModalWord : true 
            });
            this.fileUpload(this.state.up_file);
        }else{
            alert('seleccione un archivo');
        }
        
    };

    fileChange = e => {
        console.log("fileChange  - INI");

        this.setState(
        { up_file: e.target.files[0], up_fileName: e.target.files[0].name },
        () => {
            console.log(
            "Archivo seleccionado --->",
            this.state.up_file,
            console.log("nombre del archivo  --->", this.state.up_fileName)
            );
        }
        );
    };

    fileUpload = async file => {
        let METHODNAME = 'fileUpload - ';
        console.log(METHODNAME + "INI");

        auth0Client.isExpired();

        const dataForm = new FormData();
        dataForm.append("file", file); 

        var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(.docx)$");
        if (!regex.test(file.name.toLowerCase())) {
            //lblError.innerHTML = "Please upload files having extensions: <b>" + allowedFiles.join(', ') + "</b> only.";
            console.error('Formato no soportado. Solo se aceptan archivos .docx');
            this.setState({
                modalWordErrorLabel : 'Formato no soportado. Solo se aceptan archivos .docx',
                showDimmerModalWord : false 
            });
            return false;
        }

        let url = `${server}/resolucionRacPlantilla/${this.state.resolucionRacPlantillaId_word}/upload`;

        await fetch( url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:dataForm
        }).then((result) => {
            console.log(METHODNAME + 'RESPUESTA OBTENIDA');
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'grabado correctamente' );
                    
                    this.setState({
                        resolucionRacPlantillaId_word : null , 
                        showModalWord : false 
                    }); 
                    this.cargarLista();
                    
                }else{
                    console.warn(METHODNAME +  'No se pudo grabar la informacion' );
                    console.warn(METHODNAME +  'error : ' + resp.error );
                    this.setState({
                        showDimmerModalWord : false 
                    });
                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error);
                this.setState({
                    showDimmerModalWord : false 
                });
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error);
            this.setState({
                showDimmerModalWord : false 
            });
        });
        
    };
    
  render() {

    const { error, isLoaded,  listaPlantillas } = this.state;

    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div>Loading...</div>;
    } else {

            return(
                <div>
            <Container>

                <Header as='h2' content='Lista de Plantillas' style={style.h1} textAlign='center' />

                <Table celled>
                        <Table.Header>
                            <Table.Row key='head0002'> 
                                <Table.HeaderCell width={1}>ID</Table.HeaderCell>
                                <Table.HeaderCell width={3}>consecuencia</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Código</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Nombre del Archivo</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Link TC</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Word</Table.HeaderCell> 
                                <Table.HeaderCell width={1}>Acciones</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                
                        <Table.Body>
                            { listaPlantillas && listaPlantillas.map(plantilla => (
                                <Table.Row key={plantilla.resolucionRacPlantillaId}>
                                    <Table.Cell>{plantilla.resolucionRacPlantillaId} </Table.Cell>
                                    <Table.Cell>{plantilla.resolucionRac.consecuencia} </Table.Cell>
                                    <Table.Cell>{plantilla.codigo} </Table.Cell> 
                                    <Table.Cell>{plantilla.nombre ? plantilla.nombre : ''}</Table.Cell>
                                    <Table.Cell>
                                        {plantilla.link ? 
                                            <a href={plantilla.link} target='_blank' rel="noreferrer"> {plantilla.codigo} </a> 
                                            : '' 
                                        }
                                    </Table.Cell>
                                    <Table.Cell> 
                                        {plantilla.tienePlantillaDocx === 1 ? 
                                            <a href={ serverPu + '/dwnPlantilla?id='+plantilla.resolucionRacPlantillaId} target='_blank' rel="noreferrer"> {plantilla.nombre} </a>
                                            : '--'}
                                    </Table.Cell> 
                                    <Table.Cell> 
                                        
                                        <Button color='teal' animated="vertical" size='mini' 
                                                onClick={ () => this.cargarWord( plantilla.resolucionRacPlantillaId )}  >
                                            <Button.Content visible>
                                                <Icon name="upload" />
                                            </Button.Content>
                                            <Button.Content hidden>
                                                Cargar
                                            </Button.Content>
                                        </Button>

                                    </Table.Cell>
                                </Table.Row>
                            ))}

                        </Table.Body>

                    </Table>
               
            </Container>
            
            <Modal
                as={Form}
                onSubmit={this.onFormSubmit}
                closeIcon
                closeOnEscape={false}
                onClose={() => this.setShowModalWord(false)} 
                open={this.state.showModalWord}
            >
                <Modal.Header>Plantilla Word con ponencia recomendada</Modal.Header>

                <Modal.Content>

                <Modal.Description>
                    <Dimmer active={this.state.showDimmerModalWord} inverted >
                        <Loader>Loading</Loader>
                    </Dimmer>                 
                    <Form.Field>
                        
                        <Button as="label" htmlFor="file" type="button" animated="fade" color='teal'>
                            <Button.Content visible>
                                <Icon name="file outline" />
                            </Button.Content>
                            <Button.Content hidden>Seleccionar archivo</Button.Content>
                        </Button>
                        <input
                            type="file"
                            id="file"
                            hidden
                            onChange={this.fileChange}
                            accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        />
                        <Form.Input
                            fluid
                            label="Archivo seleccionado: "
                            placeholder="Usar el botón superior para buscar el archivo en su computadora"
                            readOnly
                            value={this.state.up_fileName}
                        />                        

                        {this.state.up_statusCode && this.state.up_statusCode === 200 ? (
                        <Progress
                            style={{ marginTop: "20px" }}
                            percent={100}
                            success
                            progress
                        >
                            Carga satisfactoria
                        </Progress>
                        ) : this.state.up_statusCode && this.state.up_statusCode === 500 ? (
                        <Progress
                            style={{ marginTop: "20px" }}
                            percent={100}
                            error
                            active
                            progress
                        >
                           Falló la carga 
                        </Progress>
                        ) : null}
                    </Form.Field>
                    { this.state.modalWordErrorLabel !== '' &&  
                    <Form.Field>
                         <Label color='red'>{this.state.modalWordErrorLabel}</Label>
                    </Form.Field>                   
                     }
                </Modal.Description>

                </Modal.Content>
          
                <Modal.Actions> 
                    <Button color='blue' onClick={() => this.setShowModalWord(false)}>
                        Cancelar
                    </Button> 
                    <Button negative
                            style={{ marginTop: "20px" }} 
                            type="submit">
                        Cargar archivo
                    </Button>

                </Modal.Actions>

            </Modal>
            </div>
            );

        }
  }

}